import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "tw-absolute tw-inset-0 tw-z-0 tw-bg-gradient-to-br tw-from-transparent tw-to-deep-orange-300"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "avatar",
    "data-testid": "studio-avatar",
    class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-bg-cover tw-bg-center tw-font-medium tw-leading-none tw-tracking-wider tw-text-white", {
      'tw-h-8 tw-w-8 tw-text-xs': _ctx.size === 'md',
      'tw-h-6 tw-w-6 tw-text-2xs': _ctx.size === 'sm',
      'tw-h-10 tw-w-10 tw-text-sm': _ctx.size === 'lg',
      'tw-text-md tw-h-12 tw-w-12': _ctx.size === 'xl',
      'tw-h-4 tw-w-4 tw-text-[7px]': _ctx.size === 'xs',
      'tw-cursor-pointer': _ctx.clickable
    }]),
    style: _normalizeStyle({
      backgroundColor: _ctx.cloudfrontSrc ? 'transparent' : _ctx.getAvatarColor(),
      backgroundImage: _ctx.cloudfrontSrc ? `url(${_ctx.cloudfrontSrc})` : ''
    }),
    title: _ctx.name
  }, [
    (!_ctx.cloudfrontSrc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!_ctx.cloudfrontSrc)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getInitials()), 1))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}